// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-gatsby-theme-document-src-templates-docs-js": () => import("./../../../node_modules/gatsby-theme-document/src/templates/docs.js" /* webpackChunkName: "component---node-modules-gatsby-theme-document-src-templates-docs-js" */)
}

